import actionTypes from '../constants/action-types';
import generateId from '../helpers/generate-id';

const translatePage = (
  targetPageId,
  {
    locale,
    title,
    displayInNavigation = false,
    isMultilingualSite = false,
    name = null,
    options = {},
  }
) => ({
  type: actionTypes.TRANSLATE_PAGE,
  payload: {
    targetPageId,
    displayInNavigation,
    locale,
    title,
    name: name || title,
    pageId: generateId(),
    isMultilingualSite,
    options,
  },
});

export default translatePage;
